import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgCheckmarkAlt = function SvgCheckmarkAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#checkmark-alt_svg__clip0)"
  }, React.createElement("path", {
    d: "M12 0C5.39 0 0 5.39 0 12s5.39 12 12 12 12-5.39 12-12S18.61 0 12 0zm0 21.984c-5.531 0-9.984-4.5-9.984-9.984 0-5.531 4.5-9.984 9.984-9.984 5.531 0 9.984 4.5 9.984 9.984A9.963 9.963 0 0112 21.984z"
  }), React.createElement("path", {
    d: "M17.297 7.313l-7.266 7.265-3.281-3.281a1.02 1.02 0 00-1.406 0 1.02 1.02 0 000 1.406l3.984 3.985c.188.187.469.28.703.28.235 0 .516-.093.703-.28l7.97-7.97a1.02 1.02 0 000-1.405c-.423-.375-1.032-.375-1.407 0z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "checkmark-alt_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))));
};

export default SvgCheckmarkAlt;